<template>
  <div class="app-main-inner">
    <el-dialog
      :visible.sync="visible"
      :title="$t('ChangeCharge.ChangeTheChargesInTheExpenseReview')"
      width="1300px"
      :close-on-click-modal="false"
      :show-close="false"
      class="before-and-after-comparison"
      top="10vh"
      @open="showDialog"
      @close="resetDialog"
    >
      <div class="app-main-inner-row" style="padding: 0 0 0 10px; height: 28px;">
        <el-form :inline="true" label-width="60px" label-position="right">
          <span style="font-size: 13px;font-weight: bold;">{{ $t('SeaExport.receivable') }}</span>
        </el-form>
      </div>
      <div id="vsPage1" class="app-main-inner-row row-grid" style="height: 150px; padding: 0;">
        <cargo-ag-grid
          key="chargeGrid1"
          config-module="13011112"
          :grid-params.sync="chargeBeforeGrid.gridParams"
          :grid-options="chargeBeforeGrid.gridOptions"
          :column-defs="chargeBeforeGridColumnDefs"
          :row-data="receivableRowData"
          :show-side-bar="true"
          :auto-fit-content="false"
          min-height="150"
          style="height:150px;width: 100%;"
        />
      </div>
      <div style="display: flex; justify-content: flex-end; padding-right: 10px; height: 30px; background-color: #f5f7f7;">
        <span style="font-size: 13px;" v-text="$t('CargoMsg.Cargo_AmountToP')" />
        <div style="padding-right: 10px;display: inline-block;vertical-align: middle">
          <div style="display: flex;justify-content: space-between;">
            <charge-currency-total-group
              :key="1"
              amount-to-currency="RMB"
              :data-provider="receivableRowData"
              type="ar"
            />
          </div>
        </div>
      </div>
      <div class="app-main-inner-row" style="padding: 0 0 0 10px; height: 28px;">
        <el-form :inline="true" label-width="60px" label-position="right">
          <span style="font-size: 13px;font-weight: bold;">{{ $t('SeaExport.payable') }}</span>
        </el-form>
      </div>
      <div id="vsPage2" class="app-main-inner-row row-grid" style="height: 150px; padding: 0;">
        <cargo-ag-grid
          key="chargeGrid2"
          config-module="13011113"
          :grid-params.sync="chargeAfterGrid.gridParams"
          :grid-options="chargeAfterGrid.gridOptions"
          :column-defs="chargeAfterGridColumnDefs"
          :row-data="payableRowData"
          :show-side-bar="true"
          :auto-fit-content="false"
          min-height="150"
          style="height:150px;width: 100%;"
        />
      </div>
      <div style="display: flex; justify-content: flex-end; padding-right: 10px; height: 30px; background-color: #f5f7f7;">
        <span style="font-size: 13px;" v-text="$t('CargoMsg.Cargo_AmountToP')" />
        <div style="padding-right: 10px;display: inline-block;vertical-align: middle">
          <div style="display: flex;justify-content: space-between;">
            <charge-currency-total-group
              :key="2"
              amount-to-currency="RMB"
              :data-provider="payableRowData"
              type="ap"
            />
          </div>
        </div>
      </div>
      <div slot="footer">
        <span>
          <el-button type="primary" @click="cancel">{{ $t('CargoMsg.Cargo_Close') }}</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as ChangeChargeConstant from '@/class/cargo/model/parameters/ChangeChargeConstant'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup'
import { queryJobChangingChargeList } from '@/api/clearing/changeCharge'

export default {
  name: 'ChangingChargeDetailDialog',
  components: { ChargeCurrencyTotalGroup },
  props: {
    visible: { type: Boolean, required: true },
    jobUuid: { type: String, required: true }
  },
  data() {
    return {
      rowData: [],
      chargeBeforeGrid: {
        rowData: [],
        gridParams: {},
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressContextMenu: true,
          suppressClipboardPaste: true,
          suppressRowClickSelection: false,
          context: {
            componentParent: this
          },
          defaultColDef: {
            // sortable: false,
            // resizable: false,
            // menuTabs: []
          }
        }
      },
      chargeAfterGrid: {
        rowData: [],
        gridParams: {},
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressContextMenu: true,
          suppressClipboardPaste: true,
          suppressRowClickSelection: false,
          context: {
            componentParent: this
          },
          defaultColDef: {
            // sortable: false,
            // resizable: false,
            // menuTabs: []
          }
        }
      },
      redCellStyle: { color: 'red' }
    }
  },
  computed: {
    chargeBeforeGridColumnDefs() {
      console.log('chargeBeforeGridColumnDefs')
      return [
        { headerName: this.$t('FinanceManage.charge_chargeItem'), field: 'chargeItemId', width: 80,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        },
        { headerName: this.$t('FinanceManage.charge_settleAccountsTo'), field: 'accountId', width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('FinanceManage.charge_invoiceHeader'), field: 'invoiceTitle', width: 140 },
        { headerName: this.$t('FinanceManage.charge_somesticOrInternational'), field: 'oversea', width: 60,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.overseas') : this.$t('SeaExport.internal')
          }
        },
        { headerName: this.$t('FinanceManage.charge_drawABillOrNot'), field: 'needInvoice', width: 100,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          }
        },
        { headerName: this.$t('FinanceManage.charge_currency'), field: 'currency', width: 60 },
        { headerName: this.$t('FinanceManage.charge_exchangeRate'), field: 'exchangeRate', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00000000')
          }
        },
        { headerName: this.$t('FinanceManage.charge_unit'), field: 'measure', width: 60,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('FinanceManage.adChargeInfo_quantity'), field: 'quantity', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_PaymentReceiveMethod'), field: 'receivable', width: 100, colId: 'receivable',
          valueFormatter: params => {
            return CommonState.getNameByCode(ChangeChargeConstant.CHANGE_CHARGE_CHARGETYPE, params.value ? 1 : 0)
          }
        },
        { headerName: this.$t('FinanceManage.charge_unitPrice'), field: 'unitRate', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          }
        },
        { headerName: this.$t('FinanceManage.charge_taxIncludedPrice'), field: 'amount', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        { headerName: this.$t('FinanceManage.charge_taxExcludedPrice'), field: 'excludingTaxAmount', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        { headerName: this.$t('FinanceManage.charge_taxRate'), field: 'taxRate', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        { headerName: this.$t('FinanceManage.charge_taxAmount'), field: 'taxAmount', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        { headerName: this.$t('FinanceManage.charge_contactPerson'), field: 'contactPerson', width: 60 },
        { headerName: this.$t('FinanceManage.charge_remarks'), field: 'remarks', width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.changeChargeActionTypeLabFun(params.data.actionType) + this.$t('ChangeCharge.FeesIncurred')
          }
        },
        {
          headerName: this.$t('ChangeCharge.changeReason'),
          colId: 'changeReason',
          field: 'changeReason'
        },
        { headerName: this.$t('ChangeCharge.actionType'), field: 'actionType',
          colId: 'actionType',
          cellRenderer: (params) => {
            return ColumnUtils.changeChargeActionTypeLabFun(params.value)
          }, width: 90 },
        {
          headerName: this.$t('ChangeCharge.state'), colId: 'state',
          field: 'state',
          valueFormatter: (params) => {
            return ColumnUtils.changeChargeStateLabFun(params.value)
          }
        }
      ]
    },
    chargeAfterGridColumnDefs() {
      console.log('chargeAfterGridColumnDefs')
      return [
        { headerName: this.$t('FinanceManage.charge_chargeItem'), field: 'chargeItemId', width: 80,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        },
        { headerName: this.$t('FinanceManage.charge_settleAccountsTo'), field: 'accountId', width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('FinanceManage.charge_invoiceHeader'), field: 'invoiceTitle', width: 140 },
        { headerName: this.$t('FinanceManage.charge_somesticOrInternational'), field: 'oversea', width: 60,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.overseas') : this.$t('SeaExport.internal')
          }
        },
        { headerName: this.$t('FinanceManage.charge_drawABillOrNot'), field: 'needInvoice', width: 100,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          }
        },
        { headerName: this.$t('FinanceManage.charge_currency'), field: 'currency', width: 60 },
        { headerName: this.$t('FinanceManage.charge_exchangeRate'), field: 'exchangeRate', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00000000')
          }
        },
        { headerName: this.$t('FinanceManage.charge_unit'), field: 'measure', width: 60,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('FinanceManage.adChargeInfo_quantity'), field: 'quantity', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_PaymentReceiveMethod'), field: 'receivable', width: 100, colId: 'receivable',
          valueFormatter: params => {
            return CommonState.getNameByCode(ChangeChargeConstant.CHANGE_CHARGE_CHARGETYPE, params.value ? 1 : 0)
          }
        },
        { headerName: this.$t('FinanceManage.charge_unitPrice'), field: 'unitRate', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          }
        },
        { headerName: this.$t('FinanceManage.charge_taxIncludedPrice'), field: 'amount', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        { headerName: this.$t('FinanceManage.charge_taxExcludedPrice'), field: 'excludingTaxAmount', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        { headerName: this.$t('FinanceManage.charge_taxRate'), field: 'taxRate', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        { headerName: this.$t('FinanceManage.charge_taxAmount'), field: 'taxAmount', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        { headerName: this.$t('FinanceManage.charge_contactPerson'), field: 'contactPerson', width: 60 },
        { headerName: this.$t('FinanceManage.charge_remarks'), field: 'remarks', width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.changeChargeActionTypeLabFun(params.data.actionType) + this.$t('ChangeCharge.FeesIncurred')
          } },
        {
          headerName: this.$t('ChangeCharge.changeReason'),
          colId: 'changeReason',
          field: 'changeReason'
        },
        { headerName: this.$t('ChangeCharge.actionType'), field: 'actionType',
          colId: 'actionType',
          cellRenderer: (params) => {
            return ColumnUtils.changeChargeActionTypeLabFun(params.value)
          }, width: 90 },
        {
          headerName: this.$t('ChangeCharge.state'), colId: 'state',
          field: 'state', initialWidth: 180,
          valueFormatter: (params) => {
            return ColumnUtils.changeChargeStateLabFun(params.value)
          }
        }
      ]
    },
    receivableRowData() {
      if (!this.rowData || this.rowData.length === 0) {
        return []
      }
      return this.rowData.filter(item => item.receivable)
    },
    payableRowData() {
      if (!this.rowData || this.rowData.length === 0) {
        return []
      }
      return this.rowData.filter(item => !item.receivable)
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      queryJobChangingChargeList({ jobUuid: this.jobUuid }).then(res => {
        this.rowData = res.data
      })
    },
    showDialog() {
      console.log('showDialog:')
      this.chargeBeforeGrid.gridOptions.api.clearFocusedCell()
      this.chargeAfterGrid.gridOptions.api.clearFocusedCell()
    },
    cancel() {
      this.$emit('onCancel')
    },
    resetDialog() {
      this.$emit('onCancel')
    }
  }
}
</script>

<style lang="scss">
  .before-and-after-comparison {
    .el-dialog__body {
      padding: 2px !important;
      .el-form-item {
        margin-bottom: 0!important;
      }
    }
    .ag-theme-balham {
      .ag-cell{
        user-select: text;
      }
    }
    .redStyle {
      color: red;
    }
  }
</style>
